// extracted by mini-css-extract-plugin
export default {"box":"invoice-tile-head_box__+V5Fe","icon":"invoice-tile-head_icon__vVTL3"};